import { useState } from "react";
import { Grid, Card, CardContent, Button } from "../../../../components";
import "../../configuracoes.style.css";
import FaturamentoMensalDialog from "../dialogComponents/faturamento-mensal-dialog/faturamento-mensal-dialog.component";

const ConfiguracaoFiscalTab = ({ configuracao, onChangeValor }) => {
  const [openFaturamentoMensal, setOpenFaturamentoMensal] = useState(false);

  return (
    <Card className="p-2">
      <CardContent>
        <Grid container spacing={2} className={"config-card"}>
          <Grid item xs={8}>
            FIS001 - Valor de faturamento dos últimos 12 meses.
          </Grid>
          <Grid item xs={4}>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => setOpenFaturamentoMensal(true)}
            >
              Faturamento Mensal
            </Button>
          </Grid>
        </Grid>
      </CardContent>
      <FaturamentoMensalDialog
        open={openFaturamentoMensal}
        setOpen={setOpenFaturamentoMensal}
        valor={configuracao?.faturamentoMensal}
        onSalvar={(valorJson) => onChangeValor("faturamentoMensal", valorJson)}
      />
    </Card>
  );
};

export default ConfiguracaoFiscalTab;
